module.exports = __webpack_public_path__ + "static/media/Apple iPhone XS Gold.0628355f.png";